import { observer } from "mobx-react";
import DatePicker from "react-datepicker";
import {
  DeliveryMethod,
  OrderStatus,
  SelectOption,
} from "../../stores/index.d";
import { currentMonthStartDate, getEnumOptions } from "../../utils/functions";
import Select, { ActionMeta, SingleValue } from "react-select";
import moment from "moment";
import { IOrderFilters } from "../../stores/order";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateBack } from "@fortawesome/free-solid-svg-icons";

var optsOrderType = getEnumOptions(DeliveryMethod, true) as SelectOption[];
var optsOrderStatus = getEnumOptions(OrderStatus, true) as SelectOption[];

interface IOrderFilter {
  filters: IOrderFilters;
  setFilters: (filters: IOrderFilters) => void;
}

const OrdersFilter = observer(({ filters, setFilters }: IOrderFilter) => {
  function handleDateChange(date: Date | null, type: string): void {
    setFilters({ ...filters, [type]: date });
  }

  const handleSelectChange = (
    evt: SingleValue<SelectOption>,
    actionMeta: ActionMeta<SelectOption>
  ) => {
    setFilters({
      ...filters,
      [actionMeta.name ?? ""]: evt?.value ? _.toInteger(evt?.value) : 0,
    });
  };

  const clearFilters = () => {
    setFilters({
      orderType: 0,
      startDate: currentMonthStartDate(),
      endDate: new Date(),
      orderStatus: OrderStatus.Completed,
    });
  };

  return (
    <div className="row">
      <i>
        Filters{" "}
        <a
          className="remove text-secondary ms-2"
          href="#"
          onClick={clearFilters}
          title="Clear filters"
        >
          <FontAwesomeIcon icon={faRotateBack} className="fs-5" />
        </a>
      </i>
      <div className="col-12 col-sm-3 col-lg-3">
        <div className="form-floating mb-2">
          <DatePicker
            selected={filters.startDate}
            onChange={(date) => handleDateChange(date, "startDate")}
            maxDate={moment().toDate()}
            dateFormat="dd MMM yyyy"
            placeholderText="Start Date"
            className="form-control"
            wrapperClassName="d-block"
          />
        </div>
      </div>
      <div className="col-12 col-sm-3 col-lg-2">
        <div className="form-floating mb-2">
          <DatePicker
            selected={filters.endDate}
            onChange={(date) => handleDateChange(date, "endDate")}
            maxDate={moment().toDate()}
            dateFormat="dd MMM yyyy"
            placeholderText="End Date"
            className="form-control"
            wrapperClassName="d-block"
          />
        </div>
      </div>
      <div className="col-12 col-sm-3 col-lg-3 mb-2">
        <Select
          value={
            filters.orderType > 0
              ? optsOrderType.find(
                  (p) => _.toInteger(p.value) == filters.orderType
                )
              : null
          }
          name="orderType"
          options={optsOrderType}
          className="basic-select"
          classNamePrefix="select"
          placeholder="Order Type"
          onChange={handleSelectChange}
        />
      </div>
      <div className="col-12 col-sm-3 col-lg-3 mb-2">
        <Select
          value={
            filters.orderStatus > 0
              ? optsOrderStatus.find(
                  (p) => _.toInteger(p.value) == filters.orderStatus
                )
              : null
          }
          name="orderStatus"
          options={optsOrderStatus}
          className="basic-select"
          classNamePrefix="select"
          placeholder="Order Status"
          onChange={handleSelectChange}
        />
      </div>
    </div>
  );
});

export default OrdersFilter;
